import type { Directive } from 'vue'

/**
 * v-reveal — animación de aparición al hacer scroll (IntersectionObserver).
 * Uso: <div v-reveal />  o  <div v-reveal="120" /> (retraso en ms para stagger).
 *
 * Aplica la clase `.reveal`; al entrar en viewport agrega `.is-visible`
 * (las transiciones viven en main.css). Sin dependencias externas.
 */
export const vReveal: Directive<HTMLElement, number | undefined> = {
  mounted(el, binding) {
    el.classList.add('reveal')
    if (typeof binding.value === 'number' && binding.value > 0) {
      el.style.transitionDelay = `${binding.value}ms`
    }

    if (typeof IntersectionObserver === 'undefined') {
      el.classList.add('is-visible')
      return
    }

    const io = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible')
            io.unobserve(entry.target)
          }
        }
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' },
    )
    io.observe(el)
  },
}

export default vReveal
